// 试用赛道选择规则纯函数：前端最多可选 2 个赛道，与后端限制保持一致。

// 常量：试用最多可选择的赛道数量（与平台后端限制一致）
export const MAX_TRIAL_TRACKS = 2

// 方法：切换单个选项的选中态，超过上限时返回错误文案。
// 返回 { next: string[], error: string }
export function toggleTrialSelection(selected, value, max = MAX_TRIAL_TRACKS) {
  const list = Array.isArray(selected) ? selected.slice() : []
  const index = list.indexOf(value)
  if (index > -1) {
    list.splice(index, 1)
    return { next: list, error: '' }
  }
  if (list.length >= max) {
    return { next: list, error: `最多选择 ${max} 个赛道` }
  }
  list.push(value)
  return { next: list, error: '' }
}

// 方法：按复选框的布尔值设置选中态，逻辑同上。
export function setTrialSelection(selected, value, checked, max = MAX_TRIAL_TRACKS) {
  const list = Array.isArray(selected) ? selected.slice() : []
  const index = list.indexOf(value)
  if (checked && index === -1) {
    if (list.length >= max) {
      return { next: list, error: `最多选择 ${max} 个赛道` }
    }
    list.push(value)
  }
  if (!checked && index > -1) {
    list.splice(index, 1)
  }
  return { next: list, error: '' }
}

// 方法：提交前校验，超过上限或为空时返回错误文案
export function validateTrialSelection(selected, max = MAX_TRIAL_TRACKS) {
  const list = Array.isArray(selected) ? selected : []
  if (list.length === 0) {
    return '请选择需要试用的功能'
  }
  if (list.length > max) {
    return `最多选择 ${max} 个赛道`
  }
  return ''
}
